import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 資産管理区分 */
enum AssetManagementType {
  normalAsset = 'NORMAL_ASSET',
  smallSumAsset = 'SMALL_SUM_ASSET',
  lumpSumDepreciableAsset = 'LUMP_SUM_DEPRECIABLE_ASSET',
  unaccountedAsset = 'UNACCOUNTED_ASSET',
  researchAndDevelopmentExpense = 'RESEARCH_AND_DEVELOPMENT_EXPENSE',
  ownershipRightsTransferLease = 'OWNERSHIP_RIGHTS_TRANSFER_LEASE',
  ownershipRightsNonTransferLease = 'OWNERSHIP_RIGHTS_NON_TRANSFER_LEASE',
}

const nameConfig = {
  normalAsset: new Map([
    [Locale.ja, '通常資産'],
    [Locale.en, 'Normal Asset'],
  ]),
  smallSumAsset: new Map([
    [Locale.ja, '少額資産'],
    [Locale.en, 'Small Sum Asset'],
  ]),
  lumpSumDepreciableAsset: new Map([
    [Locale.ja, '一括償却資産'],
    [Locale.en, 'Lump Sum Depreciable Asset'],
  ]),
  unaccountedAsset: new Map([
    [Locale.ja, '簿外資産'],
    [Locale.en, 'Unaccounted Asset'],
  ]),
  researchAndDevelopmentExpense: new Map([
    [Locale.ja, '研究開発費'],
    [Locale.en, 'Research and Development Expense'],
  ]),
  ownershipRightsTransferLease: new Map([
    [Locale.ja, '所有権移転リース'],
    [Locale.en, 'Ownership Rights Transfer Lease'],
  ]),
  ownershipRightsNonTransferLease: new Map([
    [Locale.ja, '所有権移転外リース'],
    [Locale.en, 'Ownership Rights Non Transfer Lease'],
  ]),
};

const toEnum = rawValueToEnum(AssetManagementType, AssetManagementType.normalAsset);
const toDisplay = enumToName(AssetManagementType, nameConfig);
const toDisplayWithPrefix = enumToName(AssetManagementType, nameConfig, { prefix: true });

export const assetManagementType = {
  enum: AssetManagementType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AssetManagementType };
